import type { PlayerPositionRole } from './types/players';

/** Figma showed "BATTER"/"BOWLER"/"ALLROUNDER" as display labels for the backend's
 * BATSMAN/BOWLER/etc — the role badge is uppercased via CSS anyway, this just picks
 * the wording (shared between the role filter dropdown and the player card). */
export const ROLE_LABELS: Record<PlayerPositionRole, string> = {
  BATSMAN: 'Batter',
  BOWLER: 'Bowler',
  WICKET_KEEPER: 'Wicket Keeper',
  ALL_ROUNDER: 'All-Rounder',
  BAT_ALL_ROUNDER: 'Batting All-Rounder',
  BOWLING_ALL_ROUNDER: 'Bowling All-Rounder',
};

export const PLAYER_POSITION_ROLES: PlayerPositionRole[] = [
  'BATSMAN',
  'BOWLER',
  'WICKET_KEEPER',
  'ALL_ROUNDER',
  'BAT_ALL_ROUNDER',
  'BOWLING_ALL_ROUNDER',
];

export function formatRoleLabel(role: string | null | undefined): string | null {
  if (!role) return null;
  return ROLE_LABELS[role as PlayerPositionRole] ?? role;
}

export function getPlayerInitials(firstName?: string | null, lastName?: string | null): string {
  const f = (firstName ?? '').trim().charAt(0).toUpperCase();
  const l = (lastName ?? '').trim().charAt(0).toUpperCase();
  return f + l || '-';
}
